import React from 'react';

export function LegalSectionBody({ intro, paragraphs = [], bullets = [], subsections = [] }) {
  return (
    <div className="content-prose text-sm">
      {intro && <p className="!text-mist">{intro}</p>}
      {paragraphs.map((text) => (
        <p key={text.slice(0, 48)}>{text}</p>
      ))}
      {bullets.length > 0 && (
        <ul className="list-disc">
          {bullets.map((line) => (
            <li key={line.slice(0, 48)}>{line}</li>
          ))}
        </ul>
      )}
      {subsections.map(({ heading, paragraphs: subs = [], bullets: subBullets = [] }) => (
        <div key={heading}>
          <h4>{heading}</h4>
          {subs.map((text) => (
            <p key={text.slice(0, 48)}>{text}</p>
          ))}
          {subBullets.length > 0 && (
            <ul className="list-disc">
              {subBullets.map((line) => (
                <li key={line.slice(0, 48)}>{line}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}

export default LegalSectionBody;
